// src/pages/SubscriptionPage.js
import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import BottomFooter from '../components/BottomFooter';
import '../styles/subscriptionpage.css';

export default function SubscriptionPage() {
  const { slug } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Read plan info passed from SubCategoryPage via navigate(..., { state: {...} })
  const categoryName = location.state?.categoryName || slug?.replaceAll('-', ' ') || 'Exam';
  const planIdFromState = location.state?.planId || null;
  const planPriceFromState = location.state?.planPrice ?? null;
  const planMonthsFromState = location.state?.planMonths ?? null;

console.log("Received state");
console.log(location.state);

console.log("Plan price:", planPriceFromState);
console.log("Currency:", location.state?.currency);


  const planNameFromState = location.state?.planName ?? null;
  const planBillingFromState = location.state?.planBilling ?? null; // optional

  const [isPaying, setIsPaying] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

    // Scroll to top on mount
  useEffect(() => {
    // use 'instant' to jump immediately, or 'smooth' if you prefer
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);
  

  // ---------------- Helpers ----------------
  const getLoggedInUser = () => {
    try {
      const raw = localStorage.getItem('isLogin');
      const u = raw ? JSON.parse(raw) : null;
      if (u && u.expiry && u.expiry > Date.now()) return u;
    } catch (_) {}
    return null;
  };
  const user = getLoggedInUser();
  const isLoggedIn = !!user;



  // Lazy-load Razorpay SDK
  function loadRazorpay() {
    return new Promise((resolve, reject) => {
      if (window.Razorpay) return resolve(true);
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => reject(new Error('Razorpay SDK failed to load.'));
      document.body.appendChild(script);
    });
  }

  useEffect(() => {
    if (!isLoggedIn) {
      // preserve previous behaviour: force login then land back here
      navigate('/login', { state: { redirectAfterLogin: `/subscribe-practice-test/${slug}` } });
    }
  }, [isLoggedIn, navigate, slug]);


  console.log("Sending to CreateOrder");



  // ---------------- Payment (Razorpay Test) ----------------
  const handlePayment = async () => {
    try {
      setIsPaying(true);
      setError(null);

      // 1) Ensure SDK present
      await loadRazorpay();

      // Use selected plan price if provided, else fall back to sample amount
      const displayAmount = Number(planPriceFromState ?? 299);
      // always default to USD unless explicitly provided
      const currency = "USD";
      const planId = planIdFromState || 'one_time_299';
      const planName = planNameFromState || 'Premium Access';
      const planMonths = planMonthsFromState ?? null;

      
     console.log("Sending to CreateOrder", {
    amount: displayAmount,
    currency,
    receipt: `polyquizz_${user?.userid}_${Date.now()}`,
    userId: user?.userid,
    category: categoryName,
    plan: planName
});

      // 2) Create order on your backend
      const createRes = await fetch(
        'https://epolylearning.com/Services/polyquiz.svc/CreateRazorpayOrder',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            amount: displayAmount,
            currency,
            receipt: `polyquizz_${user?.userid || 'anon'}_${Date.now()}`,
            userId: user?.userid,
            category: categoryName,
            plan: planName
          }),
        }
      );

      // Debugging: status + raw text
      const createText = await createRes.text();

      if (!createRes.ok) {
        // Try parse error body
        let errBody = createText;
        try { errBody = JSON.parse(createText); } catch (_) {}
        throw new Error(`Failed to create order (status ${createRes.status}): ${JSON.stringify(errBody)}`);
      }

      // Normalize create order response robustly
      let createJson = createText;
      if (typeof createJson === 'string') {
        try {
          createJson = JSON.parse(createText);
        } catch (e) {
          // try unquoting once
          const unq = createText.replace(/^"(.*)"$/, '$1');
          try { createJson = JSON.parse(unq); } catch (_) { /* leave as string */ }
        }
      }

      if (typeof createJson === 'string') {
        try { createJson = JSON.parse(createJson); } catch (_) {}
      }

      // helper to lookup keys case-insensitively
      function getCI(obj, ...keys) {
        if (!obj || typeof obj !== 'object') return undefined;
        const lowered = {};
        for (const k of Object.keys(obj)) lowered[k.toLowerCase()] = obj[k];
        for (const key of keys) {
          const val = lowered[key.toLowerCase()];
          if (typeof val !== 'undefined') return val;
        }
        return undefined;
      }

      // Extract order id + amount + currency + keyId (robustly)
      const orderid =
        getCI(createJson, 'orderId', 'orderid', 'order_id', 'id') ||
        (createJson?.order && getCI(createJson.order, 'id')) ||
        null;

      const amountFromServer =
        getCI(createJson, 'amount') ||
        getCI(createJson, 'amount_in_paise') ||
        (createJson?.order && getCI(createJson.order, 'amount')) ||
        displayAmount;

      const orderCurrency =
        getCI(createJson, 'currency') ||
        (createJson?.order && getCI(createJson.order, 'currency')) ||
        currency;

      // 3) Open Razorpay Checkout
      const rzp = new window.Razorpay({
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: amountFromServer,
        currency: orderCurrency || currency,
        name: 'PolyQuizz',
        description: `${categoryName} – ${planName}`,
        order_id: orderid,
        prefill: {
          name: user?.firstname || user?.username || 'PolyQuizz User',
          email: user?.email || ''
        },
        theme: { color: '#4f46e5' },
        handler: async function (response) {
          try {
            // 4) Verify payment on backend
            const verifyRes = await fetch(
              'https://epolylearning.com/Services/polyquiz.svc/VerifyRazorpayPayment',
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  userId: user?.userid,
                  category: categoryName,
                  planId,
                  planName,
                  planMonths,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_signature: response.razorpay_signature
                })
              }
            );

            const verifyText = await verifyRes.text();

            if (!verifyRes.ok) {
              let err = verifyText;
              try { err = JSON.parse(verifyText); } catch (_) {}
              throw new Error('Verification endpoint error: ' + JSON.stringify(err));
            }

            // server might return JSON string or object
            let verifyJson;
            try { verifyJson = JSON.parse(verifyText); } catch (_) { verifyJson = verifyText; }

            // if server returns { success: true } or similar
     if ((verifyJson && (verifyJson.success === true || verifyJson.Success === true)) || verifyJson === 'success' || verifyRes.status === 200) {
  try {
    // ✅ Step 1: Save subscription details to backend
    await fetch('https://epolylearning.com/Services/polyquiz.svc/SaveUserSubscription', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userId: user?.userid,
        category: categoryName,
        planName,
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_order_id: response.razorpay_order_id,
      }),
    });

    // ✅ Step 2: Optionally update localStorage to reflect subscription
    try {
      const raw = localStorage.getItem('isLogin');
      if (raw) {
        const parsed = JSON.parse(raw);
        parsed.subscribedCategories = parsed.subscribedCategories || [];
        if (!parsed.subscribedCategories.includes(categoryName)) {
          parsed.subscribedCategories.push(categoryName);
        }
        localStorage.setItem('isLogin', JSON.stringify(parsed));
      }
    } catch (_) {}

    // ✅ Step 3: Update UI to show success state
    setIsSuccess(true);
    setIsPaying(false);
  } catch (apiErr) {
    console.error('Subscription save failed:', apiErr);
    setError('Payment succeeded but subscription data could not be saved. Please contact support.');
  }
} else {
  throw new Error('Payment verification returned failure: ' + JSON.stringify(verifyJson));
}


          } catch (e) {
            console.error('Verification error:', e);
            setError('Payment captured but verification failed. Please contact support with your Payment ID.');
          } finally {
            setIsPaying(false);
          }
        },
        modal: {
          ondismiss: function () {
            console.log('Razorpay modal dismissed by user');
            setIsPaying(false);
          }
        },
        notes: { category: categoryName, planId }
      });

      rzp.open();
    } catch (e) {
      console.error('handlePayment error', e);
      setError(e.message || 'Unable to start payment. Please try again.');
      setIsPaying(false);
    }
  };

  // UI helpers for price display text
  // prefer USD by default; if state explicitly says INR show rupee sign
const currencySymbol = '$';

  const displayPriceLabel = () => {

 console.log(categoryName);
      
      console.log(planNameFromState);
      console.log(user?.userid,)
      

    if (planMonthsFromState) {
      return `${currencySymbol}${planPriceFromState} • ${planMonthsFromState} month${planMonthsFromState > 1 ? 's' : ''}`;
    }
    if (location.state?.planBilling) {
      return `${currencySymbol}${planPriceFromState} • ${location.state.planBilling}`;
    }
    return `${currencySymbol}${planPriceFromState ?? 299} • One-time`;

    
  };

  return (
    <>
      

      <div className="subscribe-hero">
        <div className="subscribe-container">
          <div className="subscribe-badge">Premium Access</div>
          <h1 className="subscribe-title">Unlock {categoryName.toUpperCase()}</h1>
          <p className="subscribe-subtitle">
            Get full access to sectional practice tests, full-length practice tests,
            detailed explanations, and performance tracking.
          </p>

          <div className="pricing-box">
            <div className="pricing-header">
              <span className="price-amount">{displayPriceLabel()}</span>
            </div>

            <div className="pricing-meta">
              <strong>Plan Validity:</strong> {planNameFromState || 'Premium Access'}
            </div>

            <ul className="pricing-features">
            
              <li>✔ Topic-wise and full-length Mocks</li>
              <li>✔ Detailed analytics</li>
              <li>✔ Unlimited attempts</li>
            </ul>

           {error && <div className="subscribe-error" role="alert">{error}</div>}

{isSuccess ? (
  <div className="subscribe-success" role="status" style={{ marginTop: 16 }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <div style={{
        width: 46,
        height: 46,
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #10b981, #34d399)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        fontSize: 24,
        fontWeight: 'bold',
        boxShadow: '0 4px 10px rgba(16,185,129,0.25)'
      }}>✓</div>
      <div>
        <div style={{ fontWeight: 700, fontSize: 16 }}>Subscription Successful!</div>
        <div style={{ color: '#475569', fontSize: 13 }}>You now have full access to {categoryName}.</div>
      </div>
    </div>

    <div style={{ marginTop: 18 }}>
      <button
        className="primary-btn-lg"
        onClick={() => navigate(`/practice-test-exam-prep/${slug}`, { state: { type: 'category-test' } })}
      >
        Go to Practice Tests
      </button>
    </div>
  </div>
) : (
  <>
    <button
      className={`primary-btn-lg ${isSuccess ? 'subscribed' : ''}`}
      onClick={handlePayment}
      disabled={isPaying || isSuccess}
    >
      {isPaying ? 'Processing Payment…' : isSuccess ? 'Subscribed' : `Subscribe — ${currencySymbol}${planPriceFromState ?? 299}`}
    </button>

    <p className="secure-note">🔐 Secure checkout — no recurring charges.</p>
  </>
)}

          </div>
        </div>
      </div>


    </>
  );
}
